import React from 'react';
import { Carousel } from 'components/carousel/carousel';
import { footerPaymentIcons } from 'components/footer/footer-menu';

const carouselSettings = {
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 6000,
  easing: 'linear',
  lazyLoad: false,
  pauseOnHover: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  rows: 1,
  variableWidth: true
};

export const FooterPaymentsSlider = () => (
  <Carousel
    settings={carouselSettings}
  >
    {footerPaymentIcons.map(({ title, icon: Icon }) => (
      <span key={title} className="d-inline footer-icons-container my-auto align-middle text-center mx-1 mx-md-2 mt-0_5">
        <Icon className="p-0_25 p-md-0" />
      </span>
    ))}
  </Carousel>
);
